import moment from 'moment';

import { emailValidator } from './emailValidator';
import { inputLengthValidator } from './inputLengthValidator';
import { nameValidator } from './nameValidator';
import { passwordValidator } from './passwordValidator';
import { phoneNumberValidator } from './phoneNumberValidator';
import { requiredFieldValidator } from './requiredFieldVaildator';
import { VALIDATION as messages } from './validationMessages';

const validateExpirationDate = ({
  year,
  month,
}: {
  year: string;
  month: string;
}): { isValid: boolean; error?: string } => {
  const validExpiration = moment(`${year.padStart(4, '0')}-${month.padStart(2, '0')}-01`)
    .endOf('month')
    .isAfter(moment().toDate());
  if (validExpiration) {
    return { isValid: true };
  } else {
    return { isValid: false, error: 'Expiration Date must be in a future date' };
  }
};

export const Validator = {
  password: passwordValidator,
  email: emailValidator,
  length: inputLengthValidator,
  required: requiredFieldValidator,
  name: nameValidator,
  phoneNumber: phoneNumberValidator,
  messages,
  expirationDate: validateExpirationDate,
};

export * from './websiteValidator';
